import Button from "./Buttons/Button";
import Icon from "./Icon";
import ItemScrollbar from "./ItemScrollbar";
import Text from "./Text";
import ToggleSwitch from "./ToggleSwitch";
import { useState, useEffect } from "react";
import { getWorkspace } from "../Model/Workspace";

const CrudPage = ({ title, noItemTitle = null, subtitle, items, crudActions, displayMethod, scrollbarOptions = null, toggleButtonOptions = null, isAdminPage = false, border = "", allowedTarget = null, currentTargetValue = null }) => {
    const [workspace, setWorkspace] = useState(null)
      useEffect(()=>{
        async function saveWorkspace(){
          const data = await getWorkspace()
          setWorkspace(data)
        }
        saveWorkspace()
      },[])
    const subscription = workspace?.subscription;
    const isTester = workspace?.freeTester;

    const isAllowed = (() => {
        // Nix mitgegeben -> immer erlaubt
        if (!allowedTarget || currentTargetValue === null || currentTargetValue === undefined) {
            return true;
        }
        if(isTester){
            return true
        }
        if (!subscription) {
            return false;
        }

        const actualValue = subscription[allowedTarget];
        if (actualValue === null || actualValue === undefined) {
            return true;
        }

        if (typeof actualValue === "boolean") {
            return actualValue === currentTargetValue;
        }

        if (typeof actualValue === "number") {
            return currentTargetValue < actualValue;
        }

        return false;
    })();

    const validCrudActions = (crudActions || []).filter(Boolean);
    const createAction = validCrudActions.find(a => a.type === "create");
    const customAction = validCrudActions.find(a => a.type === "custom");

    const ItemCard = ({ item }) => (
        <div className="w-full h-min bg-white rounded-md border border-black flex flex-row p-3 items-center justify-between">
            <div className="flex flex-row items-center gap-3 w-full">
                <div className="flex flex-col gap-2 flex-1 break-words overflow-hidden text-ellipsis">
                    {displayMethod ? displayMethod(item) : null}
                </div>

                <div className="flex flex-row gap-2">
                    { validCrudActions
                            .filter((action) => action.type !== "create" && action.type !== "custom")
                            .map((action, idx) => (
                                <Button
                                    key={idx}
                                    buttonColor="bg-white"
                                    classNames="w-9 h-9 p-2"
                                    tIconName={action.icon}
                                    tIconColor={action.color}
                                    onClickAction={(e) => action.action(e, item)}
                                />
                            ))
                    }
                </div>
            </div>
        </div>
    );

    return (
        <div className="w-full h-full flex flex-col gap-2 min-h-0">
            <div className="flex flex-col w-full">
                <Text type="maintitle" classNames="w-full flex flex-shrink-0">{title}</Text>
                {subtitle && (
                    <Text type="itemmain" classNames="w-full flex flex-shrink-0">{subtitle}</Text>
                )}
            </div>

            {toggleButtonOptions && (
                <div className="flex-shrink-0">
                    <ToggleSwitch toggleObjects={toggleButtonOptions} />
                </div>
            )}

            {scrollbarOptions && (
                <div className="flex-shrink-0">
                    <ItemScrollbar
                        itemType={scrollbarOptions.itemType}
                        items={scrollbarOptions.items}
                        onClickAction={scrollbarOptions.onClickAction}
                        itemDisplayOption={scrollbarOptions.itemDisplayOption}
                        colorDisplayOption={scrollbarOptions.colorDisplayOption}
                        alwaysColored={scrollbarOptions.alwaysColored}
                    />
                </div>
            )}

            <div className="w-full flex-1 flex flex-col gap-2 min-h-0">
                <div className={`w-full flex-1 flex flex-col gap-1 ${border} rounded-md p-1 min-h-0`}>

                    {(isAllowed || isAdminPage) && createAction && (
                        <Button
                            classNames="w-full flex-shrink-0"
                            buttonColor={createAction.color || "bg-white"}
                            textClasses={createAction.textClasses || "text-blue-500"}
                            text="+ Erstelle neu"
                            onClickAction={(e) => createAction.action(e)}
                        />
                    )}

                    {(isAllowed || isAdminPage) && customAction && (
                        <Button
                            classNames="w-full flex-shrink-0"
                            buttonColor={customAction.color || "bg-green-400"}
                            text={customAction.text}
                            tIconName={customAction.tIconName}
                            onClickAction={(e) => customAction.action(e)}
                        />
                    )}

                    <div className="w-full flex-1 flex flex-col gap-1 overflow-y-auto min-h-0">
                        {items.length > 0 ? items.map((item, index) => (
                            <ItemCard key={item.id || index} item={item} />
                        )) : (
                            <div className="h-full flex flex-col items-center justify-center">
                                <Text type="maintitle" classNames="flex justify-center items-center">{noItemTitle ? noItemTitle : `Keine ${title} vorhanden` } </Text>
                                <Icon classNames="w-40 h-40" iconName="cross_rectangle.svg" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CrudPage;